import { NnSundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const getOrCreateNnSundvaegtProgram =
    async (): Promise<NnSundVaegtProgramDto> => {
        return await fetchIStatus<NnSundVaegtProgramDto, void>(
            '/api/nnsundvaegt/program',
            'GET',
        );
    };
